/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-extra-boolean-cast */
function getBasePath() {
  if (typeof __webpack_public_path__ !== 'undefined') {
    return __webpack_public_path__;
  }
  return '';
}
export function pathResolver(resourcePath) {
  return `${getBasePath()}${resourcePath}`;
}